export default __webpack_public_path__ + "static/media/gallery - story - other (1)_05.acff8632.jpg";